import { Component, OnInit, OnChanges, Input, OnDestroy } from '@angular/core';
import { Dictionary, Beneficiary, Employee } from '@akiba/models_bimbo';
import { FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog } from '@angular/material';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';
import { take } from 'rxjs/operators';
import { analytics } from 'firebase';

@Component({
  selector: 'app-ss-user-registration',
  templateUrl: './ss-user-registration.component.html',
  styleUrls: ['./ss-user-registration.component.scss']
})
export class SsUserRegistrationComponent implements OnInit, OnDestroy {

  currentEmployee: Employee;
  //////////////////////////////////////

  shareSaving: any = {
    active: true,
    beneficiaries: new Dictionary<Beneficiary>(Beneficiary),
    contributionAmount: 0,
    payment: 0,
    numberOfPayments: 0,
    parametersID: '',
    status: '',
    subscriptionDate: new Date()

  };

  formControlContributionAmount = new FormControl();

  beneficiariesTitles = ['Primer Beneficiario', 'Segundo Beneficiario', 'Tercer Beneficiario', 'Cuarto Beneficiario', 'Quinto Beneficiario',
    'Sexto Beneficiario', 'Séptimo Beneficiario', 'Octavo Beneficiario', 'Noveno Beneficiario', 'Décimo Beneficiario'];

  beneficiariesPrefix = ['firstBeneficiary', 'secondBeneficiary', 'thirdBeneficiary', 'fourthBeneficiary', 'fifthBeneficiary',
    'sixthBeneficiary', 'seventhBeneficiary', 'eighthBeneficiary', 'ninthBeneficiary', 'tenthBeneficiary'];

  beneficiariesControls = new Array<Array<FormControl>>();
  shareSavingsUserData: any;
  appLogicSubs: Subscription;


  @Input() contentLocation: AppState;
  @Input() shareSavingsParameters: any;
  @Input() newParameter: any;
  
  plantilla = '../../../../../assets/img/plantilla.png';
  calculateMessage = '';
  paymentMessageError = '';
  paymentMessageSave = 'Calcula el descuento por nómina antes de continuar.';
  paymentValid: boolean = false;

  constructor(public logicService: LogicService, public dialog: MatDialog, private dataService: DataSourceService, private UI: UiService, private authService: AuthenticationService) {

    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;
    this.activeShareSaving();
  }

  async ngOnInit() {


    let beneficiariesTmp = new Dictionary<Beneficiary>(Beneficiary);
    const shareSavingsData = await this.dataService.shareSavings(this.currentEmployee.uid,this.newParameter );
    
    const obj = shareSavingsData ? shareSavingsData.docs.map(x => x.data()) : [];

    console.log('shareSavingsData', obj[0]);

    if (obj.length > 0) {
      const values = Object.values(obj[0].beneficiaries);
      if (values.length) {
        for (let index = 0; index < values.length; index++) {
          const element = values[index];
          beneficiariesTmp.add(this.beneficiariesPrefix[index], new Beneficiary(element));
        }

      }
      this.shareSaving = obj[0];
      this.shareSaving.beneficiaries = beneficiariesTmp;

    }

    if (this.shareSaving.beneficiaries.values().length === 0) {
      this.shareSaving.beneficiaries.add('firstBeneficiary', new Beneficiary({ index: 0 }));
    }

    this.shareSaving.beneficiaries.values().forEach(element => {
      const f = [new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required, Validators.min(1), Validators.max(100)])];
      f[0].setValue(element.names);
      f[1].setValue(element.firstLastName);
      f[2].setValue(element.secondLastName);
      f[3].setValue(element.relation);
      f[4].setValue(element.percentage);
      this.beneficiariesControls.push(f);
    });

    this.formControlContributionAmount.setValidators([this.customValidator(this.shareSavingsParameters.minMonto, this.shareSavingsParameters.maxMonto)]);
  }

  async activeShareSaving() {

    const dataShareSavings = await this.dataService.loadShareSavingsUser(this.currentEmployee.uid).pipe(take(1)).toPromise();
    if (dataShareSavings.length > 0) {
      this.shareSavingsUserData = dataShareSavings[0];
    }

  }

  get activeUser(): boolean {

    if (this.shareSavingsUserData && this.shareSaving.status == 'active') {
      return true;
    }

    return false;
  }

  async validateAmount(): Promise<void> {

    if (!this.formControlContributionAmount.valid || this.shareSaving.contributionAmount < 1) {

      let aMessage = '';
      if (this.shareSaving.contributionAmount <= 0) {
        aMessage = 'El importe de ahorro solicitado debe de ser mayor a cero';
      } else if (this.shareSaving.contributionAmount < this.shareSavingsParameters.minMonto) {
        aMessage = 'El importe de ahorro solicitado debe de ser mayor al mínimo';
      } else if (this.shareSaving.contributionAmount > this.shareSavingsParameters.maxMonto) {
        aMessage = 'El importe de ahorro solicitado debe de ser menor al máximo';
      }

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: aMessage,
          close: 'Aceptar'
        }
      });

      return Promise.reject(false);

    }

    return;

  }

  async validateBeneficiaries(): Promise<void> {


    const validPercentage = this.beneficiariesControls.map(element => element[4].value ? Number(element[4].value) : 0).reduce((prev, next) => prev + next);
    let aMessage: string;

    if (validPercentage < 100) {
      aMessage = 'El porcentaje de los beneficiarios da un total menor al 100%.';
    } else if (validPercentage > 100) {
      aMessage = 'El porcentaje de los beneficiarios da un total mayor al 100%.';
    }

    const missingValues = this.beneficiariesControls.reduce((prev, next) => next ? prev.concat(next) : prev).some(element => {
      return !element.value ? true : false;
    });

    if (missingValues) {
      aMessage = aMessage ? aMessage + '<br>La información de los beneficiarios esta incompleta.' : 'La información de los beneficiarios esta incompleta.';
    }

    if (aMessage) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: aMessage + '<br>Por favor verifica la información.',
          close: 'Aceptar'
        }
      });

      return Promise.reject(false);

    }

    return;

  }

  async validateForm(): Promise<boolean> {

    return this.validateAmount().then(() => {
      return this.validateBeneficiaries();
    }).then(() => {
      return true;
    }).catch(() => {
      return false;
    });

  }


  calculateDisabled(): boolean {
    let result: boolean = false;
    if (this.shareSaving.contributionAmount <= 0) {
      this.paymentValid = false;
      this.paymentMessageError = '';
      this.shareSaving.payment = 0;
      this.calculateMessage = 'El importe de ahorro solicitado debe ser mayor a cero, por favor vuelve a capturar el importe de ahorro solicitado';
      result = true;
    } else if (this.shareSaving.contributionAmount < this.shareSavingsParameters.minMonto) {
      this.paymentValid = false;
      this.shareSaving.payment = 0;
      this.calculateMessage = 'El importe de ahorro solicitado está por debajo del monto mínimo, por favor vuelve a capturar tu importe de ahorro solicitado';
      this.paymentMessageError = '';
      result = true;
    } else if (this.shareSaving.contributionAmount > this.shareSavingsParameters.maxMonto) {
      this.paymentValid = false;
      this.shareSaving.payment = 0;
      this.paymentMessageError = '';
      this.calculateMessage = 'El importe de ahorro solicitado es mayor al monto máximo de ahorro, por favor vuelve a capturar tu importe de ahorro solicitado';
      result = true;

    }
    return result;
  }

  async logPermanentLoanMovements() {
    //salvar en logs alta
    const withdraws: Array<any> = [];
    const date = new Date();

    const paramLogs = {
      employeeNumber: this.currentEmployee.workInformation.employeeNumber,
      modificationDate: date,
      withdraws: withdraws,
      registerFor: this.authService.authEmployee.uid,
      action: 'ss-user-registration'
    }
    await this.dataService.saveLogPermanentLoanMovements(paramLogs).catch(error => {
      console.log(error);
      return;
    });
  }


  submitSubscription() {

    if (!this.paymentValid && this.shareSaving.payment > 0) {
      this.UI.stopSpinner();
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El valor de la cuota de descuento supera tu liquido de nómina, por favor vuelve a capturar el importe de ahorro solicitado',
          close: 'Aceptar'
        }
      });
      return;
    }

    this.validateForm().then(valid => {

      if (!valid) {
        return;
      }

      const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
        data: {
          message: 'El importe de tu adquisición de ahorro de acciones es de $' + this.shareSaving.contributionAmount + ', ¿estás seguro de querer continuar?',
          cancelButton: 'Cancelar',
          confirmButton: 'Aceptar'
        }
      });

      dialogConfirmation.afterClosed().subscribe(result => {

        if (result) {

          this.UI.showSpinner();
          this.shareSaving.status = 'pending';
          this.shareSaving.active = true;

          this.beneficiariesControls.forEach((anArray, index) => {
            const dictionaryKey = this.beneficiariesPrefix[index];
            const beneficiary = this.shareSaving.beneficiaries.item(dictionaryKey);
            beneficiary.names = anArray[0].value[0].toUpperCase() + anArray[0].value.substr(1).toLowerCase();
            beneficiary.firstLastName = anArray[1].value[0].toUpperCase() + anArray[1].value.substr(1).toLowerCase();
            beneficiary.secondLastName = anArray[2].value[0].toUpperCase() + anArray[2].value.substr(1).toLowerCase();
            beneficiary.relation = anArray[3].value[0].toUpperCase() + anArray[3].value.substr(1).toLowerCase();
            const p = anArray[4].value;
            beneficiary.percentage = p ? Number(p) : 0;
            this.shareSaving.beneficiaries.add(dictionaryKey, beneficiary);
          });

          this.shareSaving.parametersID = this.shareSavingsParameters.parametersID;
          this.shareSaving.scheduleDateID = this.shareSavingsParameters.scheduleDateID;
          this.shareSaving.numberOfPayments = this.shareSavingsParameters.cuotas;
          const toObj = this.shareSaving;
          toObj.beneficiaries = this.shareSaving.beneficiaries.toObject();
         // toObj.scheduleDateID = 
          toObj.user = {
            contractNumber: this.shareSavingsUserData.contractNumber,
            employeeNumber: this.shareSavingsUserData.employeeNumber,
            investmentType: this.shareSavingsUserData.investmentType,
            userName: this.currentEmployee.displayName

          }

          this.logPermanentLoanMovements();
          this.dataService.registerShareSavings(toObj).then(() => {

            this.UI.stopSpinner();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'Tu solicitud ha sido registrada con éxito, por favor descargar e imprime tu carta compromiso de compra de acciones y fírmala',
                close: 'Aceptar'
              }
            });

          });

        }

      });

    }).catch(error => {

      this.UI.stopSpinner();
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No fue posible realizar el registro, inténtelo mas tarde',
          close: 'Aceptar'
        }
      });

    });

  }

  cancel(tabIndex: number, detailIndex: number | null) {
    const cancelRegistration = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    cancelRegistration.afterClosed().subscribe(result => {
      if (result) {
        this.ngOnInit();
        this.beneficiariesControls = new Array<Array<FormControl>>();
        this.shareSaving = {
          active: true,
          beneficiaries: new Dictionary<Beneficiary>(Beneficiary),
          contributionAmount: 0,
          payment: 0,
          numberOfPayments: 0,
          parametersID: '',
          status: '',
          subscriptionDate: new Date()
      
        };

      }
    });
  }

  addBeneficiary() {

    const percentageSum = this.beneficiariesControls.length > 0 ? this.beneficiariesControls.map(element => element[4].value ? Number(element[4].value) : 0).reduce((prev, next) => prev + next) : 0;

    if (percentageSum > 0 && percentageSum < 100) {

      const percentageForNewControl = 100 - percentageSum;
      const newArray = [new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required, Validators.min(1), Validators.max(100)])];
      newArray[4].setValue(percentageForNewControl);
      this.beneficiariesControls.push(newArray);
      const len = this.beneficiariesControls.length - 1;
      this.shareSaving.beneficiaries.add(this.beneficiariesPrefix[len], new Beneficiary({ index: len }));

    } else if (percentageSum === 0) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que ingrese un porcentaje válido antes de añadir mas beneficiarios',
          close: 'Aceptar'
        }
      });

    } else {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El porcentaje total es igual o mayor al 100%, para añadir mas beneficiarios<br>modifique los porcentajes para que el total sea menor al 100%.',
          close: 'Aceptar'
        }
      });

    }

  }

  removeLastBeneficiary() {

    const len = this.beneficiariesControls.length - 1;
    const beneficiariesTitle = this.beneficiariesTitles[len];
    const deleteBeneficiary = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea eliminar el ' + beneficiariesTitle + ' ?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    deleteBeneficiary.afterClosed().subscribe(result => {
      if (result) {

        this.beneficiariesControls.pop();
        this.shareSaving.beneficiaries.remove(this.beneficiariesPrefix[len]);

      }
    });

  }

  ////////////////////////////////////////////////////////

  currencyInputChanged(value: string) {

    const num = value.replace(/[$,]/g, '');
    const intValue = Number(num);
    return intValue;

  }

  customValidator(min: number, max: number): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      let result: any | null = null;

      if (!control.value) {
        return result;
      }

      const num = control.value ? control.value.replace(/[$,]/g, '') : 0;
      const intValue = Number(num);

      if (isNaN(intValue)) {
        result = { min: true };
      } else if (intValue < min) {
        result = { min: true };
      } else if (intValue > max) {
        result = { max: true };
      }

      return result;

    };

  }

  descargarInfo() {

    window.open(this.shareSavingsParameters.downloadURL, "_blank");

  }

  calculate() {
    this.shareSaving.payment = 0;
    const thirtyPercentRule = (0.30 * this.currentEmployee.periodWage);
    const wageLiq = (0.30 * this.currentEmployee.wageLiquidity);
    let max: number;

    if (thirtyPercentRule > 0 && wageLiq > 0) {
      max = Math.max(thirtyPercentRule, wageLiq);
    } else {
      max = 0;
    }

    this.shareSaving.payment = this.shareSaving.contributionAmount / this.shareSavingsParameters.cuotas;

    if (max < this.shareSaving.payment) {
      this.paymentValid = false;
      this.paymentMessageError = "El valor de la cuota de descuento supera tu liquido de nómina, por favor vuelve a capturar el importe de ahorro solicitado, tu liquido de nómina es de: $ " + max.toFixed(2);
    } else {
      this.paymentValid = true;

    }
  }


  ////////////////////////////////////////////////////////

  ngOnDestroy(): void {
    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }
  }

}